import { isInstallerNativeApp } from './installerSms';
import { apiUrl } from './apiConfig';

const getCapacitor = () => {
    if (typeof window === 'undefined') {
        return null;
    }

    return window.Capacitor || null;
};

export const getInstallerUpdatePlugin = () => {
    if (!isInstallerNativeApp()) {
        return null;
    }

    const Cap = getCapacitor();

    if (Cap?.Plugins?.InstallerUpdate) {
        return Cap.Plugins.InstallerUpdate;
    }

    if (typeof Cap?.registerPlugin === 'function') {
        return Cap.registerPlugin('InstallerUpdate');
    }

    return null;
};

export const getInstalledAppInfo = async () => {
    const plugin = getInstallerUpdatePlugin();

    if (!plugin) {
        return null;
    }

    return plugin.getAppInfo();
};

export const fetchRemoteAppUpdate = async () => {
    const response = await fetch(
        apiUrl('/api/installer/app-update'),
        {
            headers: {
                Accept: 'application/json'
            }
        }
    );

    if (!response.ok) {
        throw new Error(
            'Не удалось проверить обновление'
        );
    }

    return response.json();
};

export const isUpdateAvailable = (
    localInfo,
    remote
) => {
    if (!localInfo || !remote) {
        return false;
    }

    const localCode = Number(
        localInfo.versionCode || 0
    );
    const remoteCode = Number(
        remote.versionCode || 0
    );

    return remoteCode > localCode;
};

export const ensureInstallPermission =
    async () => {
        const plugin = getInstallerUpdatePlugin();

        if (!plugin) {
            throw new Error(
                'Обновление доступно только в APK'
            );
        }

        const status =
            await plugin.canRequestPackageInstalls();

        if (status?.allowed) {
            return true;
        }

        await plugin.openInstallPermissionSettings();

        throw new Error(
            'Разрешите установку из этого приложения и нажмите «Обновить» снова'
        );
    };

export const downloadAndInstallApk = async url => {
    const plugin = getInstallerUpdatePlugin();

    if (!plugin) {
        throw new Error(
            'Обновление доступно только в APK'
        );
    }

    await ensureInstallPermission();

    return plugin.downloadAndInstall({ url });
};
